import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import {ImageDTO, VariantDTO, ProductsDTO, ProductImgDTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class variantService implements OnInit {
    public Products: ProductsDTO[];
    public Source: LocalDataSource;

    constructor(private http: HttpClient, private notifcationService: NotificationService) {
        this.Source = new LocalDataSource();
        //this.Products=new Array<ProductDTO>();
    }

    addVariant(Variant: VariantDTO) {

        return this.http.post(environment.apiUrl + "/Variant", Variant).subscribe(
            data => {
                this.notifcationService.showSuccess("Variant", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Variant", "ajout avec success");
                console.error(error);
            }
        );

    }
    updateVariant(Variant: VariantDTO) {

        return this.http.post(environment.apiUrl + "/Variant/UpdateProduct", Variant).subscribe(
            data => {
                this.notifcationService.showSuccess("Variant", "Variant Modified");
            },
            (error) => {
                this.notifcationService.showError(error.error.body,error.error.message,);
                console.error(error);
            }
        );
    }

    getVariant(idProduct:number){
        return this.http.get<VariantDTO[]>(environment.apiUrl + "/Variant/"+idProduct)
        .pipe(
         catchError(this.handleError)
        );
    }

    getImgProduct(idProduct:string){
        return this.http.get<ProductImgDTO[]>(environment.apiUrl + "/Variant/ProductImg/"+idProduct)
        .pipe(
         catchError(this.handleError)
        );
    }


    getVariants(source: boolean): any {
        if (source) {
            this.http.get<VariantDTO[]>(environment.apiUrl + "/Variant").pipe(
                catchError(this.handleError)

            );
        } else {
            this.http.get<VariantDTO[]>(environment.apiUrl + "/Variant").pipe(
                catchError(this.handleError)

            );
        }

    }

    getAllVariants(): any {
        return this.http.get<VariantDTO[]>(environment.apiUrl + "/Variant")
            .pipe(
                catchError(this.handleError)
            );
    }

    getVariantImage(idVariant:number,Idvariant:number):any{
        return this.http.get<ImageDTO>(environment.apiUrl + "/Variant/"+idVariant+"/"+Idvariant)
            .pipe(
                catchError(this.handleError)
            );
    }

    deleteVariant(idVariant: number) {
        this.http.delete<any>(environment.apiUrl + "/Variant/" + idVariant).subscribe(
            data => {
                this.notifcationService.showSuccess("Variant", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Variant", "suppression avec success");
                console.error(error);
            }
        );
    }
    
    deleteImg(idImg: number) {
        this.http.delete<any>(environment.apiUrl + "/Product/ProductImg/" + idImg).subscribe(
            data => {
                this.notifcationService.showSuccess("Img", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Img", "suppression avec success");
                console.error(error);
            }
        );
    }


    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
    };



}

